export class Page {
    constructor() {
    }

    render() {
    }

    show() {
    }

    hide() {
    }
}